module.exports = __webpack_public_path__ + "img/kongshuju.1635299289416.png";